import React from "react";
import { Stack, Typography } from "@mui/material";
import Tooltip from "@hyro-components/Tooltip";
import QuestionIcon from "src/icons/insights/QuestionIcon";
import {
  ANALYTICS_SUBTITLE,
  ANALYTICS_TITLE,
  ANALYTICS_TOOLTIP,
  VALUE_REFERENCES_SUBTITLE,
  VALUE_REFERENCES_TITLE
} from "./AnalyticsSettings.consts";
import { CHAT_CHANNEL } from "../AgentSettings.consts";
import SetupSelect from "./SetupSelect";
import BenchmarksTable from "./BenchmarksTable";
import SwitchSetupDialog from "./SwitchSetupDialog";
import ValueReferencesTable from "./ValueReferencesTable";

const AnalyticsSettingsTab = ({ analyticsSettingsProps }) => {
  const {
    activeSetup, setSelectedSetup, allSetups, benchmarks, hasOverrides,
    isLoading, isError, onBenchmarkUpdate,
    pendingSetup, confirmSetupChange, cancelSetupChange,
    valueReferences, onValueReferenceUpdate, channel
  } = analyticsSettingsProps;
  const pendingSetupName = allSetups?.find((s) => s.id === pendingSetup)?.name;
  // Chat agents all sit on the single default benchmarks setup, so there is nothing to
  // choose; and no chat page computes value-generated metrics yet, so the dollar value
  // references would have no effect. Both controls are hidden rather than shown inert.
  const isChat = channel === CHAT_CHANNEL;
  const canChooseSetup = !isChat;
  const hasValueReferences = !isChat;

  return (
    <Stack direction="column" gap={3}>
      <Stack direction="column" gap="2px">
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography variant="h6">{ANALYTICS_TITLE}</Typography>
          <Tooltip title={ANALYTICS_TOOLTIP} variant="light">
            <QuestionIcon />
          </Tooltip>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {ANALYTICS_SUBTITLE}
        </Typography>
      </Stack>
      {canChooseSetup && (
        <SetupSelect
          setups={allSetups}
          selectedSetup={activeSetup}
          hasOverrides={hasOverrides}
          onChange={setSelectedSetup}
          loading={isLoading}
        />
      )}
      <BenchmarksTable benchmarks={benchmarks} loading={isLoading} onBenchmarkUpdate={onBenchmarkUpdate} />
      {hasValueReferences && (
        <>
          <Stack direction="column" gap="2px">
            <Typography variant="h6">{VALUE_REFERENCES_TITLE}</Typography>
            <Typography variant="body2" color="text.secondary">
              {VALUE_REFERENCES_SUBTITLE}
            </Typography>
          </Stack>
          <ValueReferencesTable
            valueReferences={valueReferences}
            loading={isLoading}
            onValueReferenceUpdate={onValueReferenceUpdate}
          />
        </>
      )}
      <SwitchSetupDialog
        open={!!pendingSetup}
        setupName={pendingSetupName}
        hasCustomBenchmarks={hasOverrides}
        onConfirm={confirmSetupChange}
        onCancel={cancelSetupChange}
      />
    </Stack>
  );
};

export default AnalyticsSettingsTab;
